import { Collapse } from '@material-ui/core'
import Button from 'components/common/Button/Button'
import {
  StyledModalBoxSection,
  StyledRuleSettings,
  StyledTitle,
  StyledTitleHint,
  StyledCondition,
} from 'components/common/Modals/styles'
import { TRIGGER_ASSIGNMENTS } from 'constants/jobsTriggers'
import { isEmpty } from 'lodash'
import React from 'react'
import { injectIntl, WrappedComponentProps } from 'react-intl'
import { ReactComponent as TriggersAssignmentIcon } from 'assets/img/users-group-2.svg'
import { JobsTriggersAssignmentSectionProps } from './JobsTriggersAssignmentSection.types'
import messages from '../translate'

export const JobsTriggersAssignmentSection = ({
  intl: { formatMessage },
  isOpened,
  setIsOpened,
  isDefaultAssignment,
  setIsAssignmentSubModalOpened,
  formData,
}: JobsTriggersAssignmentSectionProps & WrappedComponentProps) => (
  <StyledModalBoxSection>
    <StyledRuleSettings>
      <StyledTitle
        expandable
        opened={isOpened}
        onClick={() => {
          setIsOpened(!isOpened)
        }}>
        <TriggersAssignmentIcon />
        {formatMessage(messages.assignment)}
        {isDefaultAssignment && (
          <StyledTitleHint>
            {` ${formatMessage(messages.defaultAssignees)}`}
          </StyledTitleHint>
        )}
      </StyledTitle>
      <Collapse in={isOpened}>
        <StyledCondition align="center" wrap="wrap">
          <Button
            type="secondary"
            onClick={() => setIsAssignmentSubModalOpened(true)}
            disabled={isEmpty(formData[TRIGGER_ASSIGNMENTS])}>
            {formatMessage(messages.editAssignees)}
          </Button>
        </StyledCondition>
      </Collapse>
    </StyledRuleSettings>
  </StyledModalBoxSection>
)

export default injectIntl(JobsTriggersAssignmentSection)
